import getAxiosInstance from "../../common/mhiAxios";
import {
    SlideComment,
    SlideCommentChangeSet,
} from "../../models/SlideComment";
import {
    CreateSlideIF,
    EditSlideIF,
    parseSlide,
    UploadDocumentIF
} from "../../models/slides";

export default {
    // コンテンツアップロードでURL生成
    createTempFile(tempFile: File): Promise<any> {
        const params = new FormData();
        params.append("tempFile", tempFile);
        return getAxiosInstance()
            .post("/api/createTempFile", params, {
                headers: {
                    accept: "*/*",
                    "content-type": "multipart/form-data",
                },
            })
            .then(({ data }) => data)
            .catch((error) => {
                return error;
            });
    },

    // tempファイルのページ総数の取得
    getTempPageCount(keyName: string): Promise<any> {
        return getAxiosInstance()
            .get(`/api/getPageCount?keyName=${keyName}`)
            .then(({ data }) => data)
            .catch((error) => {
                return error;
            });
    },

    // tempファイル表示URLの取得
    getTempPreviewUrl(keyName: string, pageNo: number): Promise<any> {
        return getAxiosInstance()
            .get("/api/getPagePreviewUrl", { params: { keyName: keyName, pageNo: pageNo } })
            .then(({ data }) => data)
            .catch((error) => {
                return error;
            });
    },

    // 新規コンテンツ作成
    createNewSlide(newSlide: CreateSlideIF): Promise<any> {
        const params = new FormData();
        params.append(
            "content",
            new Blob([JSON.stringify(newSlide.content)], {
                type: "application/json",
            })
        );
        // documentFile
        if (newSlide.documentFile.length > 0) {
            newSlide.documentFile.map((row) => params.append("documentFile", row));
        } else {
            params.append("documentFile", new File([""], "empty"));
        }

        // documentName
        if (newSlide.documentName.length > 0) {
            params.append("documentName", JSON.stringify(newSlide.documentName));
        } else {
            params.append("documentName", String(newSlide.documentName));
        }
        return getAxiosInstance()
            .post("/api/createContent", params, {
                headers: {
                    "content-type": "multipart/form-data",
                },
            })
            .then(({ data }) => data)
            .catch((error) => {
                return error;
            });
    },

    // 新規コンテンツ作成キャンセルでtempファイルの削除
    deleteTempFile(keyName: string): Promise<any> {
        return getAxiosInstance()
            .delete(`/api/deleteTempFile?keyName=${keyName}`)
            .then(({ data }) => data)
            .catch((error) => {
                return error;
            });
    },

    // コンテンツ情報取得
    getSlideById(userId: number, id: number): Promise<any> {
        return getAxiosInstance()
            .get("/api/getSlideById", { params: { userId: userId, id: id } })
            .then(({ data }) => parseSlide(data))
            .catch((error) => {
                return error;
            });
    },

    // コンテンツページ総数の取得
    getSlidePageCount(id: number, fileName: string): Promise<any> {
        const url = encodeURIComponent(fileName);
        return getAxiosInstance()
            .get(`/api/getPageCount?keyName=${id}-${url}`)
            .then(({ data }) => data)
            .catch((error) => {
                return error;
            });
    },

    // コンテンツ表示URLの取得
    getSlidePreviewImageUrl(id: number, fileName: string, pageNo: number): Promise<any> {
        const keyName = id + "-" + fileName;
        return getAxiosInstance()
            .get("/api/getPagePreviewUrl", { params: { keyName: keyName, pageNo: pageNo } })
            .then(({ data }) => data)
            .catch((error) => {
                return error;
            });
    },

    // コンテンツ編集
    editSlide(editSlideInfo: EditSlideIF): Promise<any> {
        // Todo documentファイル追加
        return getAxiosInstance()
            .post("/api/editSlide", { ...editSlideInfo.content })
            .then(({ data }) => parseSlide(data))
            .catch((error) => {
                return error;
            });
    },

    // コンテンツの削除
    deleteSlide(id: number): Promise<any> {
        return getAxiosInstance()
            .delete(`/api/document/${id}`)
            .then(({ data }) => data)
            .catch((error) => {
                return error;
            });
    },

    // コンテンツのコメント
    createSlideComment(changeSet: SlideCommentChangeSet): Promise<SlideComment> {
        return getAxiosInstance()
            .post("/api/addSlideComment", changeSet)
            .then(({ data }) => data)
            .catch((error) => {
                return error;
            });
    },

    updateSlideComment(changeSet: SlideCommentChangeSet): Promise<SlideComment> {
        return getAxiosInstance()
            .post("/api/updateSlideComment", changeSet)
            .then(({ data }) => data)
            .catch((error) => {
                return error;
            });
    },
    deleteSlideComment(id: number, userId: number, documentId: number): Promise<SlideComment> {
        return getAxiosInstance()
            .post("/api/deleteSlideComment", { id, userId, documentId })
            .then(({ data }) => data)
            .catch((error) => {
                return error;
            });
    },
    replayToSlideComment(changeSet: SlideCommentChangeSet): Promise<SlideComment> {
        return getAxiosInstance()
            .post("/api/replayToSlideComment", changeSet)
            .then(({ data }) => data)
            .catch((error) => {
                return error;
            });
    },

    // コンテンツ資料アップロード
    UploadDocument(document: UploadDocumentIF): Promise<any> {
        const params = new FormData();

        // userId
        params.append("userId", String(document.userId));

        // videoId
        params.append("slideStockId", String(document.slideStockId));

        // materialId
        if (document.materialId.length > 0) {
            let sendMaterialId = "";
            document.materialId.map((row) => {
                if (sendMaterialId !== "") {
                    sendMaterialId = sendMaterialId + "," + String(row);
                } else {
                    sendMaterialId = String(row);
                }
                return null;
            });
            params.append(
                "materialId",
                new Blob([sendMaterialId], {
                    type: "application/json",
                })
            );
        } else {
            params.append(
                "materialId",
                new Blob([JSON.stringify("")], {
                    type: "application/json",
                })
            );
        }

        // documentFile
        if (
            document.documentFile !== undefined &&
            document.documentFile !== null &&
            document.documentFile.length > 0
        ) {
            document.documentFile.map((row) => params.append("documentFile", row));
        } else {
            params.append("documentFile", new File([""], "empty"));
        }

        // documentName
        if (document.documentName.length > 0) {
            let sendDocumetName = "";
            document.documentName.map((row) => {
                if (sendDocumetName !== "") {
                    sendDocumetName = sendDocumetName + "," + row;
                } else {
                    sendDocumetName = row;
                }
                return null;
            });

            params.append(
                "documentName",
                new Blob([sendDocumetName], {
                    type: "application/json",
                })
            );
        } else {
            params.append(
                "documentName",
                new Blob([JSON.stringify("")], {
                    type: "application/json",
                })
            );
        }

        // 送信
        return getAxiosInstance()
            .post("/api/uploadDocumentMaterial", params, {
                headers: {
                    "content-type": "multipart/form-data",
                },
            })
            .then(({ data }) => data)
            .catch((error) => {
                return null;
            });
    },
};